import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';

export default class SlideDownBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.slideDown = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let isVisible = ko.unwrap(valueAccessor());
                let element = $(node);

                if (isVisible) {
                    element.slideDown(100);
                    element.css('min-width', element.innerWidth());
                } else {
                    element.slideUp(100);
                }
            }
        };
    }
}